// Validación de formato por tipo de campo del formulario público. Espejo de
// `Forms::SubmissionValidatorService` (Ruby) para que cliente y servidor validen
// igual. La presencia de campos requeridos se valida aparte; aquí solo se
// verifica el formato de los valores presentes (un campo vacío es válido).

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const BOOLEAN_VALUES = ['true', 'false'];

const fieldLabel = field => field.label || field.name;

const messageFor = (field, suffix) =>
  `El campo '${fieldLabel(field)}' ${suffix}`;

const emailError = (field, value) =>
  EMAIL_REGEX.test(value)
    ? null
    : messageFor(field, 'tiene un formato de correo inválido');

const numberError = (field, value) => {
  const num = Number(value);
  if (Number.isNaN(num)) return messageFor(field, 'debe ser un número válido');
  if (field.min != null && num < Number(field.min))
    return messageFor(field, `debe ser mayor o igual a ${field.min}`);
  if (field.max != null && num > Number(field.max))
    return messageFor(field, `debe ser menor o igual a ${field.max}`);
  return null;
};

const dateError = (field, value) =>
  Number.isNaN(Date.parse(value))
    ? messageFor(field, 'tiene una fecha inválida')
    : null;

const checkboxError = (field, value) =>
  BOOLEAN_VALUES.includes(value.toLowerCase())
    ? null
    : messageFor(field, 'tiene un valor inválido');

const optionsError = (field, value) => {
  const allowed = (field.values || []).map(option => String(option));
  if (!allowed.length || allowed.includes(value)) return null;
  return messageFor(field, 'tiene una opción no válida');
};

const textError = (field, value) => {
  if (!field.regex_pattern) return null;
  try {
    return new RegExp(field.regex_pattern).test(value)
      ? null
      : messageFor(field, 'no cumple el formato requerido');
  } catch (error) {
    return null;
  }
};

// Devuelve un mensaje de error o null si el valor (no vacío) es válido para el tipo.
export const validateValue = (field, rawValue) => {
  const value = (
    rawValue === null || rawValue === undefined ? '' : String(rawValue)
  ).trim();
  if (value === '') return null;

  switch (field.type) {
    case 'email':
      return emailError(field, value);
    case 'number':
      return numberError(field, value);
    case 'date':
      return dateError(field, value);
    case 'checkbox':
      return checkboxError(field, value);
    case 'list':
    case 'radio':
      return optionsError(field, value);
    default:
      return textError(field, value);
  }
};

// Valida todos los campos contra los valores dados. Devuelve un arreglo de
// { name, message } para los campos con error de formato.
export const validateFields = (fields = [], values = {}) =>
  fields
    .map(field => {
      const message = validateValue(field, values[field.name]);
      return message ? { name: field.name, message } : null;
    })
    .filter(Boolean);
